module.exports = __webpack_public_path__ + "static/media/ride.d43ed2a2.ogg";